import * as React from 'react'
import type { SVGProps } from 'react'
const SvgPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={2}
      d="m9.7923 4.4807.7301 1.3083c.6589 1.1807.3944 2.7295-.6433 3.7673 0 0-1.2587 1.2589 1.0235 3.5412 2.2815 2.2815 3.5411 1.0235 3.5411 1.0235 1.0378-1.0378 2.5866-1.3023 3.7673-.6434l1.3083.7301c1.7829.995 1.9934 3.4952.4263 5.0623-.9416.9416-2.0952 1.6744-3.3703 1.7226-2.1467.0815-5.7922-.4618-9.4491-4.1187-3.657-3.657-4.2002-7.3025-4.1188-9.4492.0483-1.2751.781-2.4287 1.7226-3.3703 1.5671-1.567 4.0673-1.3565 5.0623.4263Z"
    />
  </svg>
)
export default SvgPhone
